import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "admin-overview" }
const _hoisted_2 = { class: "overview-hero" }
const _hoisted_3 = { class: "overview-kicker" }
const _hoisted_4 = { class: "overview-range" }
const _hoisted_5 = { class: "overview-presets" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "overview-date-row" }
const _hoisted_8 = { class: "overview-grid overview-grid--metrics" }
const _hoisted_9 = { class: "metric-card__head" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "admin-section" }
const _hoisted_12 = { class: "section-head" }
const _hoisted_13 = {
  key: 0,
  class: "admin-loading"
}
const _hoisted_14 = {
  key: 1,
  class: "trend-grid"
}
const _hoisted_15 = { class: "trend-card__head" }
const _hoisted_16 = { class: "mini-chart" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "overview-grid overview-grid--detail" }
const _hoisted_19 = { class: "admin-section admin-section--panel" }
const _hoisted_20 = { class: "section-head" }
const _hoisted_21 = {
  key: 0,
  class: "admin-loading"
}
const _hoisted_22 = {
  key: 1,
  class: "funnel-stack"
}
const _hoisted_23 = { class: "funnel-row__label" }
const _hoisted_24 = { class: "funnel-row__track" }
const _hoisted_25 = { class: "admin-section admin-section--panel" }
const _hoisted_26 = { class: "section-head" }
const _hoisted_27 = {
  key: 0,
  class: "admin-loading"
}
const _hoisted_28 = {
  key: 1,
  class: "value-list"
}
const _hoisted_29 = {
  key: 2,
  class: "admin-note"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.rangeHint), 1),
        _cache[8] || (_cache[8] = _createElementVNode("h2", null, "运营概览", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", null, "聚焦用户增长、任务转化和可计费页面，隐藏当前不可追踪或恒为 0 的噪声指标。", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (preset) => {
            return (_openBlock(), _createElementBlock("button", {
              key: preset.days,
              type: "button",
              class: _normalizeClass(['overview-preset', { 'overview-preset--active': _ctx.selectedPreset === preset.days }]),
              onClick: ($event: any) => (_ctx.applyPreset(preset.days))
            }, _toDisplayString(preset.label), 11, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
            type: "date",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedPreset = 0))
          }, null, 544), [
            [_vModelText, _ctx.startDate]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "至", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event)),
            type: "date",
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedPreset = 0))
          }, null, 544), [
            [_vModelText, _ctx.endDate]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "overview-apply",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.refreshAll && _ctx.refreshAll(...args)))
          }, "应用")
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primaryMetrics, (metric) => {
        return (_openBlock(), _createElementBlock("article", {
          key: metric.label,
          class: "metric-card"
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(metric.label), 1),
            _createElementVNode("button", {
              type: "button",
              onClick: ($event: any) => (_ctx.goDetail(metric.target))
            }, "查看明细", 8, _hoisted_10)
          ]),
          _createElementVNode("strong", null, _toDisplayString(metric.loading ? '-' : metric.value), 1),
          _createElementVNode("p", null, _toDisplayString(metric.description), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[11] || (_cache[11] = _createElementVNode("div", null, [
          _createElementVNode("h2", null, "关键趋势"),
          _createElementVNode("p", null, "按天展示区间内的活跃、任务、成功和可计费页面变化。")
        ], -1)),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goDetail('tasks')))
        }, "查看任务明细")
      ]),
      (_ctx.trendsLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "加载中..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trendCards, (chart) => {
              return (_openBlock(), _createElementBlock("article", {
                key: chart.title,
                class: "trend-card"
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(chart.title), 1),
                  _createElementVNode("strong", null, _toDisplayString(chart.total), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chart.points, (point) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: `${chart.title}-${point.date}`,
                      class: "mini-chart__bar",
                      style: _normalizeStyle({ height: `${point.height}%` }),
                      title: `${point.date}: ${point.value}`
                    }, null, 12, _hoisted_17))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
    ]),
    _createElementVNode("section", _hoisted_18, [
      _createElementVNode("article", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[12] || (_cache[12] = _createElementVNode("div", null, [
            _createElementVNode("h2", null, "转化漏斗"),
            _createElementVNode("p", null, "注册、激活、首次导出到回访的有效转化。")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goDetail('users')))
          }, "查看用户")
        ]),
        (_ctx.analyticsLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, "加载中..."))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.funnelStages, (stage) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: stage.label,
                  class: "funnel-row"
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", null, _toDisplayString(stage.label), 1),
                    _createElementVNode("strong", null, _toDisplayString(stage.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ width: `${stage.width}%` })
                    }, null, 4)
                  ]),
                  _createElementVNode("em", null, _toDisplayString(stage.note), 1)
                ]))
              }), 128))
            ]))
      ]),
      _createElementVNode("article", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _cache[13] || (_cache[13] = _createElementVNode("div", null, [
            _createElementVNode("h2", null, "价值与留存"),
            _createElementVNode("p", null, "只保留能指导运营动作的成本收益代理指标。")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goDetail('points')))
          }, "查看积分流水")
        ]),
        (_ctx.analyticsLoading || _ctx.costBenefitLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, "加载中..."))
          : (_openBlock(), _createElementBlock("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.valueList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: "value-row"
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.label), 1),
                  _createElementVNode("strong", null, _toDisplayString(item.value), 1)
                ]))
              }), 128))
            ])),
        (_ctx.costAnalytics && !_ctx.costAnalytics.actualCostAvailable)
          ? (_openBlock(), _createElementBlock("p", _hoisted_29, " 实际 AI 供应商成本未持久化，当前展示按净扣页数 × ¥" + _toDisplayString(_ctx.costAnalytics.retailYuanPerPage) + "/页计算的零售价值，不等同于已收收入。 ", 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}